var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "form",
      {
        staticClass: "m-form m-form--state",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitForm.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("cam_name") },
                    "col-lg-4"
                  ]
                },
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("cam_name"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.camera_name,
                        expression: "camera_name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "cam_name",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "cam_name",
                      name: "cam_name",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_cam_name")
                      )
                    },
                    domProps: { value: _vm.camera_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.camera_name = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("cam_name"),
                          expression: "errors.has('cam_name')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("cam_name")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("cam_ip") },
                    "col-lg-4"
                  ]
                },
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("cam_ip"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.camera_ip,
                        expression: "camera_ip"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|ip",
                        expression: "'required|ip'"
                      }
                    ],
                    ref: "cam_ip",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "cam_ip",
                      name: "cam_ip",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_cam_ip")
                      )
                    },
                    domProps: { value: _vm.camera_ip },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.camera_ip = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("cam_ip"),
                          expression: "errors.has('cam_ip')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("cam_ip")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("label", { attrs: { for: "manufacturer" } }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(_vm._f("translate")("manufacturer"))
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.manufacturer,
                        expression: "manufacturer"
                      }
                    ],
                    staticClass: "form-control m_selectpicker",
                    attrs: {
                      name: "manufacturer",
                      id: "manufacturer",
                      title: _vm._f("capitalize")(
                        _vm._f("translate")("select_manufacture")
                      )
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.manufacturer = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.manufacturers, function(manu) {
                    return _c(
                      "option",
                      { key: manu.id, domProps: { value: manu.id } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(_vm._f("translate")(manu.name))
                          )
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("control_point") },
                    "col-lg-4"
                  ]
                },
                [
                  _c("label", { attrs: { for: "control_point" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("control_point")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.control_point,
                          expression: "control_point"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "form-control m_selectpicker",
                      attrs: {
                        name: "control_point",
                        id: "control_point",
                        title: _vm._f("capitalize")(
                          _vm._f("translate")("select_control_point")
                        )
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.control_point = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.control_points, function(cp) {
                      return _c(
                        "option",
                        { key: cp.id, domProps: { value: cp.id } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")(cp.name))
                            )
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("control_point"),
                          expression: "errors.has('control_point')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("control_point")) + " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("label", { attrs: { for: "mode" } }, [
                  _vm._v(
                    _vm._s(_vm._f("capitalize")(_vm._f("translate")("mode")))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.mode,
                        expression: "mode"
                      }
                    ],
                    staticClass: "form-control m_selectpicker",
                    attrs: {
                      name: "mode",
                      id: "mode",
                      title: _vm._f("capitalize")(
                        _vm._f("translate")("select_mode")
                      )
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.mode = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.modes, function(m) {
                    return _c(
                      "option",
                      { key: m.key, domProps: { value: m.name } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(_vm._f("translate")(m.name))
                          )
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("label", { attrs: { for: "reference" } }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(_vm._f("translate")("reference"))
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.reference,
                        expression: "reference"
                      }
                    ],
                    staticClass: "form-control m_selectpicker",
                    attrs: {
                      name: "reference",
                      id: "reference",
                      title: _vm._f("capitalize")(
                        _vm._f("translate")("select_reference")
                      )
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.reference = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.references, function(rf) {
                    return _c(
                      "option",
                      { key: rf.key, domProps: { value: rf.refer } },
                      [_vm._v(_vm._s(rf.refer))]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [{ "has-danger": _vm.errors.has("user") }, "col-lg-4"]
                },
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("user")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user,
                        expression: "user"
                      }
                    ],
                    ref: "user",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "user",
                      name: "user",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_cam_user")
                      )
                    },
                    domProps: { value: _vm.user },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.user = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("user"),
                          expression: "errors.has('user')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("user")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("password") },
                    "col-lg-4"
                  ]
                },
                [
                  _c("label", { attrs: { for: "password" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("password"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    ref: "password",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "password",
                      id: "password",
                      name: "password",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_cam_password")
                      )
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("password"),
                          expression: "errors.has('password')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("password")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("label", { attrs: { for: "recognition_type" } }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("recognition_type")
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.recognition_type,
                        expression: "recognition_type"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-control m_selectpicker",
                    attrs: {
                      name: "recognition_type",
                      id: "recognition_type",
                      title: _vm._f("capitalize")(
                        _vm._f("translate")(
                          "select_license_plate_recognition_type"
                        )
                      )
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.recognition_type = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.recognition_types, function(tf) {
                    return _c(
                      "option",
                      { key: tf.key, domProps: { value: tf.key } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")(tf.type_rec)
                            )
                          )
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("recognition_type"),
                        expression: "errors.has('recognition_type')"
                      }
                    ],
                    staticClass: "m-form__help m--font-danger"
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.errors.first("recognition_type")) + " "
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                id: "btn-cancel-approve-camera"
              },
              on: {
                click: function($event) {
                  return _vm.reset()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("close"))) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary-orange",
              attrs: { type: "button" },
              on: { click: _vm.test_camera }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("test"))) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("save"))) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e73d7e8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e73d7e8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cameras/NewCamera.vue
// module id = 427
// module chunks = 0 1 56 169